// Storage of subscribers
const eventsHandlers = {};

const useAppEvent = (eventName) => {
  const dispatchAppEvent = (payload) => {
    if (eventsHandlers[eventName]?.length) {
      eventsHandlers[eventName].forEach(callback => callback(payload));
    }
  }

  const subscribeToAppEvent = (callback) => {
    if (!eventsHandlers[eventName]) {
      eventsHandlers[eventName] = [];
    }
    // Do not add same function twice
    if (eventsHandlers[eventName].includes(callback)) {
      return;
    }
    eventsHandlers[eventName].push(callback);
  }

  const unsubscribeFromAppEvent = (callback) => {
    if (eventsHandlers[eventName]?.length) {
      const index = eventsHandlers[eventName].indexOf(callback);
      if (index > -1) {
        eventsHandlers[eventName].splice(index, 1)
      }
    }
  }

  
  return { dispatchAppEvent, subscribeToAppEvent, unsubscribeFromAppEvent };
};

export default useAppEvent;
